(function () {
  const checkbox = document.getElementById('CartAcknowledgement');

  if (!checkbox) return;

  const row = checkbox.closest('.cart__disclosure');
  const checkoutButton = document.getElementById('checkout');
  const dynamicButtons = document.querySelector('.cart__dynamic-checkout-buttons');
  const cartForm = document.getElementById('cart');

  function flagError() {
    row?.classList.add('cart__disclosure--error');
    checkbox.focus();
  }

  function syncState() {
    const checked = checkbox.checked;

    row?.classList.remove('cart__disclosure--error');

    if (checkoutButton) {
      checkoutButton.disabled = checkoutButton.dataset.cartEmpty === 'true' || !checked;
    }

    if (dynamicButtons) {
      dynamicButtons.classList.toggle('cart__dynamic-checkout-buttons--locked', !checked);
      dynamicButtons.setAttribute('aria-disabled', String(!checked));
    }
  }

  checkbox.addEventListener('change', syncState);
  syncState();

  if (dynamicButtons) {
    // Shop Pay / PayPal / Google Pay buttons are injected by Shopify and can't be
    // disabled directly, so intercept the click before their own handlers run.
    dynamicButtons.addEventListener(
      'click',
      (event) => {
        if (!checkbox.checked) {
          event.preventDefault();
          event.stopImmediatePropagation();
          flagError();
        }
      },
      true
    );
  }

  if (cartForm) {
    cartForm.addEventListener('submit', (event) => {
      if (!checkbox.checked) {
        event.preventDefault();
        flagError();
      }
    });
  }
})();
